<template>
    <div class="container">
      <div class="header">
        <img class="img" src="../../assets/fff3@2x.png" alt="">
        <p class="title">邀请教练 赢iPad</p>
        <p class="tip">邀请身边教练朋友下载老虎教练APP，赢取超值大礼！</p>
        
        <div class="invite_btn" @click="invite">立即邀请</div>
      </div>
      <div class="warpper">
        <!-- 邀请任务 -->
        <div class="invite_box">
          <div class="title">
            <img src="../../assets/L2.png" alt="">
            <p>邀请任务</p>
            <img src="../../assets/R2.png" alt="">
            <div class="tips_box" @click="rules">
              <img src="../../assets/wenhao.png" alt="">
              <p>如何认证</p>
            </div>
          </div>
          <!-- 奖品展示框 -->
          <div class="display_box">
            <div class="box">
              <img class="img1" src="../../assets/youhuiquan@2x.png" alt="">
              <p>39元优惠券</p>
            </div>
            <div class="box">
              <img class="img2" src="../../assets/waistband2.png" alt="">
              <p>劳拉之星腰带</p>
            </div>
            <div class="box">
              <img class="img3" src="../../assets/chuizi@2x.png" alt="">
              <p>Phoenix筋膜枪</p>
            </div>
            <div class="box">
              <img class="img4" src="../../assets/ipad@2x.png" alt="">
              <p>iPad Air(64G)</p>
            </div>
          </div>
          <div class="progress_num">
            <div class="stage">
              <p class="stage_txt">1人注册</p>
            </div>
            <div class="stage">
              <p class="stage_txt">5人认证</p>
            </div>
            <div class="stage">
              <p class="stage_txt">10人认证</p>
            </div>
            <div class="stage">
              <p class="stage_txt">20人认证</p>
            </div>
          </div>
          <!-- 进度条 -->
          <div class="progress">
            <div class="bubble" :style="'left:' + num*0.93 + '%' "><span>{{number}}人</span></div>
            <div class="line">
              <div class="line_solid" :style="'width:'+ num +'%;'"></div>
              <div class="node" :class="(num >= 25 ? 'active' : '')">
                <div class="inner_circle"></div>
              </div>
              <div class="node2" :class="(num >= 50 ? 'active' : '')">
                <div class="inner_circle"></div>
              </div>
              <div class="node3" :class="(num >= 75 ? 'active' : '')">
                <div class="inner_circle"></div>
              </div>
              <div class="node4" :class="(num >= 100 ? 'active' : '')">
                <div class="inner_circle"></div>
              </div>
            </div>
          </div>
          <div class="progress_num">
            <div class="stage">
              <!-- <p class="stage_txt">1人注册</p> -->
              <div v-if="num >= 25 ? true : false" class="btn" @click="show_box(0)">查看</div>
            </div>
            <div class="stage">
              <!-- <p class="stage_txt">5人认证</p> -->
              <div v-if="num >= 50 ? true : false" class="btn" @click="show_box(1)">去领奖</div>
            </div>
            <div class="stage">
              <!-- <p class="stage_txt">10人认证</p> -->
              <div  v-if="num >= 75 ? true : false" class="btn" @click="show_box(1)">去领奖</div>
            </div>
            <div class="stage">
              <!-- <p class="stage_txt">20人认证</p> -->
              <div v-if="num >= 100 ? true : false" class="btn" @click="show_box(1)">去领奖</div>
            </div>
          </div>
        </div>
        <!-- 我的邀请码 -->
        <div class="invite_code_box">
          <div class="title">
            <img src="../../assets/L2.png" alt="">
            <p>我的邀请码</p>
            <img src="../../assets/R2.png" alt="">
          </div>
          <div class="invite_code">
            <span>{{inviteCode}}</span>
            <button class="copy" :data-clipboard-text="inviteCode" @click="copy"><img src="../../assets/paste.png" alt=""></button>
          </div>
          <div class="input_box">
            <div v-if="showStatus" class="input">
              <input v-if="!couponStatus" type="search" placeholder="填写好友邀请码领奖" v-model="value" :class="inputStatus== true ? 'fix': '' " @focus="fix" @blur="nofix" @keyup.enter="onSubmit">
              <div v-if="!couponStatus" @click="onSubmit" class="input_btn"><img class="input_img" src="../../assets/arrow_btn.png" alt=""></div>
            </div>
            <div v-if="couponStatus" class="newgift">
              <p class="tips">新人礼</p>
              <img class="img1" src="../../assets/tips.png" alt="">
              <img class="img2" src="../../assets/youhuiquan.png" alt="">
              <p class="upper">优惠码：{{couponCode2}}</p>
              <p class="down">购买时输入优惠码立减39元</p>
              <div class="btn" @click="popupBtn(0)">去使用</div>
            </div>
          </div>
        </div>
        <!-- 我邀请的教练 -->
        <div class="myInvite">
          <div class="title">
            <img src="../../assets/L2.png" alt="">
            <p>我邀请的教练</p>
            <img src="../../assets/R2.png" alt="">
          </div>
          <div class="myCoach">
            <div class="item" v-for="item in myInviteCoach">
              <img class="avatar" v-lazy="item.avatar + '?imageView2/5/w/150/h/150'">
              <p class="coachName">{{item.nickname}}</p>
              <button class="btn" :class=" item.status == 2 ? 'certified' : 'Uncertified' " @click="remind(item.status)">{{item.status == 2 ? '已认证' : '提醒认证'}}</button>
            </div>
          </div>
        </div>
        <p class="rules">*参与本活动，即同意并遵守<span class="activity" @click="rules"><u>活动规则</u></span>，本活动与苹果公司无关！</p>

      </div>
      <!-- 背景层 -->
      <div v-if="shareStatus || popupStatus || inputStatus" @click="quit" class="shadow">
      </div>
      <!-- 分享 -->
      <div v-if="shareStatus" class="share_box">
        <!-- <div><shareBar :config="config"></shareBar></div> -->
        <div  class="box">
          <div class="item" @click="wechat">
            <img src="@/assets/weixin_friend.png" alt="">
            <p>微信</p>
          </div>
          <div class="item" @click="wechatFriend">
            <img src="@/assets/weixin.png" alt="">
            <p>朋友圈</p>
          </div>
          <div class="btn_quit" @click.stop="quit">取消</div>
        </div>
      </div>
      <!-- 礼品兑换 -->
      <div v-if="popupStatus" class="popup_box">
        <div class="top"><img class="close" src="../../assets/close.png" alt=""  @click="quit"></div>
        <p class="title"><span v-if="type==0?true:false">虎皮商城优惠券</span><span v-else-if="type==1?true:false">添加客服微信领奖</span><span v-else-if="type==2?true:false">已帮你复制消息</span><span v-else>虎皮商店小程序</span></p>
        <div v-if="type==0?true:false" class="body">
          <img class="coupon" src="../../assets/youhuiquan.png" alt="">
          <p class="couponCode"><span>优惠码：{{couponCode2}}</span></p>
          <p class="tip">购买时输入优惠码立减39元</p>
          <div v-if="status" class="scratchWrap">
            <!-- <vue-scratch-card 
              element-id='scratchWrap'
              :ratio=0.5
              :move-radius="30"
              :start-callback="startCallback"
              :clear-callback="clearCallback"
              cover-color='#666'
              result-img=""
            >
            </vue-scratch-card> -->
          </div>
        </div>
        <div v-else-if="type==1?true:false" class="body">
          <img class="qrcode" src="../../assets/wechat@2x.png" alt="">
          <p class="tip1">客服微信号</p>
          <p class="name">laohujiaolian</p>
        </div>
        <div v-else-if="type==2" class="body">
          <p class="tip2">选择好友粘贴给他！</p>
          <p class="Pastecontent">hi 我正在参加老虎教练app “邀教练赢 iPad活动”hi 我正在参加老虎教练app “邀教练赢 iPad活动”正在参加老虎教练app</p>
        </div>
        <div v-else class="body">
          <img class="qrcode" src="../../assets/qrcode.jpg" alt="">
          <p class="tip1">虎皮商店</p>
          <p class="name">长按识别小程序码进入使用</p>
        </div>
        <div v-if="type==3?false:true" class="popupBtn" data-clipboard-text="在吗？快去“老虎教练APP”完成认证，帮我拿到iPad！谢啦！" @click="popupBtn(type)"><span v-if="type==0?true:false">去使用</span><span v-else-if="type==1?true:false">知道了</span><span v-else>复制给朋友</span></div>
      </div>
      <!-- 公众号分享 -->
      <div v-if="shadowStatus" class="tip_box" @click="quit">
        <img class="tip_img1" src="../../assets/1211@2x.png" alt="">
        <img class="tip_img2" src="../../assets/liwu@2x.png" alt="">
        <p>点击右上角 立即邀请好友</p>
      </div>
    </div>
</template>

<script>
  import wx from 'weixin-js-sdk'
  import { Button,Progress,Toast,Indicator } from 'mint-ui';
  import Clipboard from 'clipboard'
  import util from '@/units/utils.js'
  import shareBar from '@/components/shareBar'
  import { getDetail,submitOtherCode,getSignature } from '@/api/api'

  export default {
    name: "activityDeatil",
    components: {
      shareBar
    },
    data() {
      return {
        num: 0, // 邀请进度百分比
        number: 0, // 邀请认证人数
        inviteCode: '', // 邀请码
        couponCode: '', // 优惠码
        couponCode2: '', // 被邀请码
        value: '',
        complete: 5, // 已邀请的人数
        myInviteCoach: [], // 我邀请的教练信息
        shareStatus: false, // 分享
        popupStatus: false, // 礼品
        status: true, // 刮刮层状态
        couponStatus: null, // 优惠框状态
        type: null,
        inputStatus: false,
        config: {
          title: '分享标题',
          desc:'描述',
          img:'https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1557036541528&di=5ffb1a3fd0657ecaca1377da8d6a3888&imgtype=0&src=http%3A%2F%2Fimg4.dwstatic.com%2Fcoc%2F1610%2F341403342700%2F1477448238976.jpghttps://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1557036541528&di=5ffb1a3fd0657ecaca1377da8d6a3888&imgtype=0&src=http%3A%2F%2Fimg4.dwstatic.com%2Fcoc%2F1610%2F341403342700%2F1477448238976.jpg',
          img_title:'图片标题',
          link: 'www.baidu.com'
        },
        showStatus: null, // 微信公众号端 邀请码输入框隐藏
        shadowStatus: null, // 微信公众号端 分享提示
      }
    },
    created() {
      var u = navigator.userAgent // 获取浏览器信息
      let aid = sessionStorage.getItem('aid') 
      let id = sessionStorage.getItem('uid')
      let flag = sessionStorage.getItem('flag')
      this.fetchdata(aid, id)
      if(flag == 0) {
        this.setWx(aid)
      }
    },
    methods: {
      async fetchdata(aid, id) {
        try {
          let flag = sessionStorage.getItem('flag')
          let res = await getDetail(aid, id)
          console.log(res)
          if(res.data.Code == 200) {
            let data = res.data.Data
            this.inviteCode = data.invitee_code
            this.number = data.invitee_cert_count
            //邀请进度跳判断
            if(data.invitee_cert_count >= 1 && data.invitee_cert_count < 5) {
              if(data.invitee_cert_count == 1) {
                this.num = 25
              } else {
                this.num = 25 + data.invitee_cert_count * 5
              }
            } else if(data.invitee_cert_count >= 5 && data.invitee_cert_count < 10) {
              if(data.invitee_cert_count == 5) {
                this.num = data.invitee_cert_count*10
              } else {
                this.num = 50 + (data.invitee_cert_count - 5) * 5
              }
            } else if (data.invitee_cert_count >= 10 && data.invitee_cert_count < 20) {
              if(data.invitee_cert_count == 10) {
                this.num = 75
              } else {
                this.num = 75 + (data.invitee_cert_count - 10) * 2.5
              }
            } else if(data.invitee_cert_count >= 20) {
              this.num = 100
            }
            // 可填邀请码 判断
            if(data.invitee_gift_code == '') {
              if(flag == 0) { // TODO::
                this.showStatus = true
              } else {
                this.showStatus = true
              }
              this.couponStatus = false
            } else {
              this.showStatus = false
              this.couponStatus = true
              this.couponCode2 = data.invitee_gift_code
            }
            this.myInviteCoach = data.invitee_list
            if(data.inviter_gift_code != '') {
              this.couponCode = data.inviter_gift_code
              this.num = 25
              this.number = 1
            } 
          }
        } catch (e) {
          e = e + ''
          if(e.indexOf('Network Error') > -1) {
            Toast({
              message: 'Network Error',
              position: 'bottom',
              duration: 2000
            })
          } else {
            Toast({
              message: 'errCode: 10002',
              position: 'bottom',
              duration: 2000
            })
          }
        }
      },
      startCallback(){
        console.log('抽奖成功！')
      },
      clearCallback(){
        console.log('清除完毕！')
        this.status = false
      },
      getSignature (aid){ //获取微信签名 
        return new Promise((resolve, reject)=>{
          let data = {
            url: window.location.href.split('#')[0]
          }
          getSignature(aid, data
          ).then( res => {
            console.log(res)
            resolve(res.data)
          }).catch((err)=>{
            reject(err)
          })
        })
      },
      async setWx(aid){ // 微信分享配置
        let res = await this.getSignature(aid)
        let {timestamp, nonceStr, appId, signature} = res.Data
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: appId, // 必填，公众号的唯一标识
          timestamp: timestamp, // 必填，生成签名的时间戳
          nonceStr: nonceStr, // 必填，生成签名的随机串
          signature: signature, // 必填，签名
          jsApiList: ["onMenuShareTimeline", "onMenuShareAppMessage"] // 必填，需要使用的JS接口列表
        });
        wx.ready(() => {
          wx.onMenuShareTimeline({
            title: '送你一台iPad', // 分享标题
            link: window.location.href.split('#')[0] + "#/appdownload?code=" + this.inviteCode,// 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: 'http://coach-10061631.image.myqcloud.com/1HfaPHvJP233q2qucKsPVkcXbFm?imageView2/3/w/88/h/90/q/15.png',// 分享图标
            success: function() {
              // 用户点击了分享后执行的回调函数
            }
          });
          wx.onMenuShareAppMessage({
            title: '送你一台iPad', // 分享标题
            desc: '快下载老虎教练app参加活动(仅限健身教练参与)', // 分享描述
            link: window.location.href.split('#')[0] + "#/appdownload?code=" + this.inviteCode, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: 'http://coach-10061631.image.myqcloud.com/1HfaPHvJP233q2qucKsPVkcXbFm?imageView2/3/w/88/h/90/q/15.png', // 分享图标
            type: "", // 分享类型,music、video或link，不填默认为link
            dataUrl: "", // 如果type是music或video，则要提供数据链接，默认为空
            success: function() {
              // 用户点击了分享后执行的回调函数
            }
          })
          // // 自定义“分享给朋友”及“分享到QQ”按钮的分享内容（1.4.0）最新接口
          // wx.updateAppMessageShareData({ 
          //     title: '邀请教练 赢iPad', // 分享标题
          //     desc: '下载老虎教练app参加活动', // 分享描述
          //     link: window.location.href.split('#')[0]+'#'+window.location.href.split('#')[1], // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          //     imgUrl: '', // 分享图标
          //     success: function () {
          //       // 设置成功
          //     }
          // })
          // // 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容（1.4.0）最新接口     
          // wx.updateTimelineShareData({ 
          //     title: '邀请教练 赢iPad', // 分享标题
          //     link: window.location.href.split('#')[0]+'#'+window.location.href.split('#')[1], // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          //     imgUrl: '', // 分享图标
          //     success: function () {
          //       // 设置成功
          //     }
          // })
        })
        wx.error(() => {
          Toast({
            message: 'errCode:10001',
            position: 'bottom',
            duration: 2000
          })
        })
      },
      copy() {  // 复制邀请码
        let clipboard = new Clipboard('.copy')
        clipboard.on('success', e => {
          console.log('复制成功')
          Toast({
            message: '复制成功',
            position: 'bottom',
            duration: 2000
          })
          // 释放内存
          clipboard.destroy()
        })
        clipboard.on('error', e => {
            // 不支持复制
            console.log('该浏览器不支持自动复制')
            // 释放内存
            clipboard.destroy()
        })
      },
      rules() { // 活动规则页面
        this.$router.push({
          name: "activityRules"
        })
      },
      invite() { // 邀请 分享弹窗
        let flag = sessionStorage.getItem('flag')
        if(flag == 0) {
          this.shareStatus = false
          this.shadowStatus = true
        } else {
          this.shareStatus = true
        }
      },
      quit() { //关闭弹窗
        this.shareStatus = false
        this.popupStatus = false
        this.shadowStatus = false
      },
      wechat() { // WebViewJavascriptBridge 原生分享
        var u = navigator.userAgent
        if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) { //安卓机

          WebViewJavascriptBridge.callHandler('share',{
            "platform": '2', // 2. 微信 \ 3. 朋友圈
            "code": this.inviteCode //邀请码
          }, function (response) {})

        } else if (u.indexOf('iPhone') > -1) { //苹果
          try {
            //使用此方法,会报错,因此使用try-catch
            window.webkit.messageHandlers.share.postMessage({
              "platform": '2', // 2. 微信 \ 3. 朋友圈
              "code": this.inviteCode //邀请码
            })
          } catch(error) {
            console.log('WKWebView post message');
          }
        }
      },
      wechatFriend() { // WebViewJavascriptBridge 原生分享
        let u = navigator.userAgent
        if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) { //安卓机

          WebViewJavascriptBridge.callHandler('share', { 
            "platform": '3', // 2. 微信 \ 3. 朋友圈
            "code": this.inviteCode //邀请码
          }, function (response) {})

        } else if (u.indexOf('iPhone') > -1) { //苹果
          try {
              //使用此方法,会报错,因此使用try-catch
             window.webkit.messageHandlers.share.postMessage({ 
              "platform": '3', // 2. 微信 \ 3. 朋友圈
              "code": this.inviteCode //邀请码
            });
          } catch(error) {
            console.log('WKWebView post message');
          }
        }
      },
      show_box(index) { // 礼品兑换弹窗
        this.type = index
        this.popupStatus = true
      },
      remind(index) { // 提醒认证
        if(index == 0) {
          this.type = 2
          this.popupStatus = true
        }
      },
      popupBtn(index) { // 礼品兑换弹窗 click
        let flag = sessionStorage.getItem('flag') 
        if(index == 0) {
          // console.log('跳转小程序')
          let u = navigator.userAgent
          if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) { //安卓

            WebViewJavascriptBridge.callHandler('mini', { //h5页面调取安卓的方法，进行分享传给android的参数，
              "id": "gh_f1e422221fe7",
              "path": "pages/home/feature/index?alias=rxGrXFM17o"
            }, function (response) {})

          } else if(u.indexOf('iPhone') > -1) { //苹果
            try {
              //使用此方法,会报错,因此使用try-catch
              window.webkit.messageHandlers.mini.postMessage({ 
                "id": "gh_f1e422221fe7",
                "path": "pages/home/feature/index?alias=rxGrXFM17o"
              });
            } catch(error) {
              console.log('WKWebView post message');
            }
          }
          this.popupStatus = false
          if(flag == 0) {
            this.popupStatus = true
            this.type = 3
          }
        } else if(index == 1) {
          console.log('跳转微信')
          this.popupStatus = false
        } else if(index == 2) {
          let clipboard = new Clipboard('.popupBtn')
          clipboard.on('success', e => {
            console.log('复制成功')
            // 释放内存
            clipboard.destroy()
            this.popupStatus = false
            let u = navigator.userAgent
            if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) { //安卓

              WebViewJavascriptBridge.callHandler('launcherWechat',function (response) {})

            } else if(u.indexOf('iPhone') > -1) { //苹果
              try {
                //使用此方法,会报错,因此使用try-catch
                window.webkit.messageHandlers.launcherWechat.postMessage()
              } catch(error) {
                console.log('WKWebView post message');
              }
            }
          })
          clipboard.on('error', e => {
              // 不支持复制
              console.log('该浏览器不支持自动复制')
              // 释放内存
              clipboard.destroy()
          })
        }
      },
      async onSubmit(e) { //提交邀请码
        try {
          let aid = sessionStorage.getItem('aid') 
          let uid = sessionStorage.getItem('uid')
          let code = this.value
          if(code != '') {
            let res = await submitOtherCode(aid, uid, code)
            // console.log(res)
            if(res.data.Code == 200) {
              this.couponStatus = true
              this.showStatus = false // 待改
              this.value = ''
              this.couponCode2 = res.data.Data.code
            } else if(res.data.Code == 451) {
              this.couponStatus = false
              Toast({
                message: '不能填自己的邀请码哦',
                position: 'bottom',
                duration: 2000
              })
              this.value = ''
            } else {
              Toast({
                message: '邀请码错误，请确认后重试',
                position: 'bottom',
                duration: 2000
              })
              this.value = ''
            }
          }
        } catch (e) {
          e = e + ''
          if(e.indexOf('Network Error') > -1) {
            Toast({
              message: 'Network Error',
              position: 'bottom',
              duration: 2000
            })
          } else {
            Toast({
              message: 'errCode: 10003',
              position: 'bottom',
              duration: 2000
            })
          }
        }
      },
      fix() {
        let u = navigator.userAgent
        if(u.indexOf('iPhone') > -1) { //苹果
          this.inputStatus = false
        } else {
          this.inputStatus = true
        }
      },
      nofix() {
        this.inputStatus = false
      }
    }
  }
</script>

<style lang="less" scoped>
  .container {
    width: 100%;
    height: 100vh;
    color: #000;
    overflow: auto;
    position: relative;
    background:linear-gradient(0deg,rgba(109,164,248,1) 0%,rgba(163,170,237,1) 19%,rgba(109,164,248,1) 37%,rgba(169,171,237,1) 56.00000000000001%,rgba(116,165,247,1) 75%,rgba(161,169,237,1) 100%);
    .header {
      width: 100%;
      position: relative;
      display: flex;
      justify-content: center;
      align-content: flex-start;
      flex-wrap: wrap;
      color: #fff;
      overflow: hidden;
      .img {
        width: 2.86rem;
        height: 2.58rem;
        margin: 0.28rem 0 0.37rem;
      }
      .title {
        width: 100%;
        text-align: center;
        height: 0.46rem;
        line-height: .46rem;
        font-size: 0.24rem;
        font-weight: 600;
      }
      .tip {
        width: 100%;
        text-align: center;
        height: 0.46rem;
        line-height: .46rem;
        font-size: 0.12rem;
        font-weight: 500;
      }
      .invite_btn {
        width: 1.5rem;
        height: 0.35rem;
        background: linear-gradient(0deg,rgba(246,198,68,1),rgba(252,238,150,1));
        border-radius: 0.17rem;
        font-size: 0.17rem;
        font-weight: 600;
        color: #E3721E;
        line-height: 0.35rem;
        text-align: center;
        margin: 0.2rem 0 0.2rem;
      }
    }
    .warpper {
      width: 100%;
      // height: 6rem;
      overflow: hidden;
      position: relative;
      .tip {
        width: 100%;
        height: 0.3rem;
        line-height: .3rem;
        text-align: center;
        font-size: 0.14rem;
        font-weight: 400;
        margin: 0.15rem 0 0.3rem;
      }
      .invite_box {
        margin: 0.15rem 0.15rem;
        background-color: #fff;
        border-radius: 0.1rem;
        overflow: hidden;
        .title {
          width: 100%;
          height: 0.15rem;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0.15rem 0;
          position: relative;
          img {
            width: 0.09rem;
            height: 0.15rem;
          }
          p {
            margin: 0 0.1rem;
            font-size: 0.15rem;
            font-weight: 600;
            color: #82A6F4;
          }
          .tips_box {
            position: absolute;
            top: 0;
            right: 0.1rem;
            widows: 1rem;
            height: 0.2rem;
            line-height: 0.2rem;
            display: flex;
            align-items: center;
            justify-content: space-around;
            img {
              width: 0.08rem;
              height: 0.08rem;
            }
            p {
              font-size: 0.08rem;
              font-weight: 500;
              color:#999;
            }
          }
        }
        .display_box {
          width: 100%;
          // height: 0.6rem;
          display: flex;
          justify-content: space-around;
          align-items: center;
          .box {
            width: 0.77rem;
            height: 0.77rem;
            background-color: #F1F6FF;
            border-radius: 0.05rem;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-wrap: wrap;
            p {
              font-size: 0.09rem;
              font-weight: 400;
              color: #999999;
            }
            .img1 {
              width: 0.6rem;
              height: 0.37rem;
            }
            .img2 {
              width: 0.63rem;
              height: 0.37rem;
            }
            .img3 {
              width: 0.35rem;
              height: 0.38rem;
            }
            .img4 {
              width: 0.27rem;
              height: 0.38rem;
            }
          }
        }
        .progress {
          width: 100%;
          height: 0.35rem;
          line-height: 0.35rem;
          margin: 0 auto 0.1rem;
          overflow: hidden;
          position: relative;
          .bubble {
            position: absolute;
            top: 0;
            width: 0.25rem;
            height: 0.20rem;
            line-height: 0.15rem;
            text-align: center;
            background: url('../../assets/bubble.png') no-repeat;
            background-position: center;
            background-size: cover;
            font-size: 0.05rem;
            font-weight: 500;
            color: #fff;
          }
          .line {
            width: 96%;
            height: 0.1rem;
            border-radius: 0.05rem;
            box-shadow: 0 0 0.01rem 0.01rem #82A6F4;
            margin: 0.2rem auto 0;
            position: relative;
            .line_solid {
              height: 0.1rem;
              background-color: #85A5F2;
              border-radius: 0.05rem;
            }
            .node {
              position: absolute;
              top: -0.025rem;
              left: 24%;
              width: 0.15rem;
              height: 0.15rem;
              background-color: #D9D9D9;
              border-radius: 50%;
              .inner_circle {
                width: 0.07rem;
                height: 0.07rem;
                margin: 0.04rem;
                background: #fff;
                border-radius: 50%;
              }
            }
            .node2 {
              position: absolute;
              top: -0.025rem;
              left: 48%;
              width: 0.15rem;
              height: 0.15rem;
              background-color: #D9D9D9;
              border-radius: 50%;
              .inner_circle {
                width: 0.07rem;
                height: 0.07rem;
                margin: 0.04rem;
                background: #fff;
                border-radius: 50%;
              }
            }
            .node3 {
              position: absolute;
              top: -0.025rem;
              left: 72%;
              width: 0.15rem;
              height: 0.15rem;
              background-color: #D9D9D9;
              border-radius: 50%;
              .inner_circle {
                width: 0.07rem;
                height: 0.07rem;
                margin: 0.04rem;
                background: #fff;
                border-radius: 50%;
              }
            }
            .node4 {
              position: absolute;
              top: -0.025rem;
              left: 96%;
              width: 0.15rem;
              height: 0.15rem;
              background-color: #D9D9D9;
              border-radius: 50%;
              .inner_circle {
                width: 0.07rem;
                height: 0.07rem;
                margin: 0.04rem;
                background: #fff;
                border-radius: 50%;
              }
            }
            .active {
              background-color: #85A5F2;
            }
          }
        }
        .progress_num {
          width: 100%;
          // height: 0.6rem;
          color: #82A6F4;
          display: flex;
          justify-content: flex-start;
          .stage {
            width: 25%;
            // height: 0.3rem;
            .stage_txt {
              width: 100%;
              height: 0.2rem;
              line-height: 0.2rem;
              text-align: center;
              font-size: .12rem;
              font-weight: 600;
            }
            .btn {
              width: 0.4rem;
              height:  0.17rem;
              line-height: 0.17rem;
              background: linear-gradient(0deg,rgba(246,198,68,1),rgba(252,238,150,1));
              box-shadow: 0px 0.025rem 0.03rem 0px rgba(0, 0, 0, 0.1);
              border-radius: 0.09rem;
              font-size: 0.09rem;
              color: #E3721E;
              margin: 0.1rem auto;
              text-align: center;
              font-weight: 600;
            }
          }
        }
      }
      .invite_code_box {
        margin: 0.15rem 0.15rem;
        background-color: #fff;
        border-radius: 0.1rem;
        overflow: hidden;
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        .title {
          width: 100%;
          height: 0.15rem;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0.15rem 0;
          img {
            width: 0.09rem;
            height: 0.15rem;
          }
          p {
            margin: 0 0.1rem;
            font-size: 0.15rem;
            font-weight: 600;
            color: #82A6F4;
          }
        }
        .invite_code {
          height: 0.5rem;
          line-height: 0.5rem;
          text-align: center;
          font-size: 0.25rem;
          font-weight: 600;
          color: #E3721E;
          img {
            width: 0.15rem;
            height: 0.15rem;
          }
        }
        .input_box {
          width: 100%;
          margin: 0.25rem 0 0.15rem;
          display: flex;
          justify-content: center;
          .input {
            position: relative;
            input {
              width: 2.5rem;
              height: 0.27rem;
              border:0.015rem solid rgba(133,165,242,1);
              border-radius: 0.14rem;
              text-align: center;
              color: #E3721E;
              &::-webkit-input-placeholder {
                color: #D9D9D9;
              }
            }
            .input_btn {
              position: absolute;
              top: 50%;
              transform: translateY(-50%);
              right: 0.1rem;
              width: 0.1rem;
              height: 0.1rem;
              .input_img {
                width: 0.1rem;
                height: 0.1rem;
              }
            }
          }
          .fix {
            position: fixed;
            top: 60%;
            left: 50%;
            transform: translateX(-50%);
            background-color: #F1F6FF;
          }
          .newgift {
            width: 90%;
            background-color: #F1F6FF;
            box-shadow:0 0.05rem 0.045rem 0 rgba(0, 0, 0, 0.1);
            position: relative;
            .tips {
              position: absolute;
              top: 0.07rem;
              left: 0;
              font-size: 0.09rem;
              font-weight: 500;
              color: #E3721E;
              transform-origin: center;
              transform: rotateZ(-45deg);
              z-index: 100;
            }
            .img1 {
              position: absolute;
              top: 0;
              left: 0;
              width: 0.37rem;
              height: 0.37rem;
            }
            .img2 {
              position: absolute;
              top: 50%;
              left: 0.4rem;
              transform: translateY(-50%);
              width: 0.67rem;
              height: 0.37rem;
            }
            .upper {
              font-size: 0.13rem;
              font-weight: 600;
              color: #F6736A;
              margin: 0.15rem 0 0.09rem 1.2rem;
            }
            .down {
              font-size: 0.09rem;
              font-weight: 300;
              color: #999;
              margin: 0 0 0.15rem 1.2rem;
            }
            .btn {
              position: absolute;
              top: 50%;
              right: 0.15rem;
              // transform: translateY(-50%);
              width: 0.5rem;
              height: 0.18rem;
              line-height: 0.18rem;
              color: #fff;
              background-color: #85A5F2;
              font-size: 0.09rem;
              font-weight: 300;
              text-align: center;
              border-radius: 0.09rem;
            }
          }
        }
      }
      .myInvite {
        margin: 0.15rem 0.15rem 0.6rem;
        background-color: #fff;
        border-radius: 0.1rem;
        overflow: hidden;
        .title {
          width: 100%;
          height: 0.15rem;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0.15rem 0;
          img {
            width: 0.09rem;
            height: 0.15rem;
          }
          p {
            margin: 0 0.1rem;
            font-size: 0.15rem;
            font-weight: 600;
            color: #82A6F4;
          }
        }
        .myCoach {
          width: 100%;
          display: flex;
          align-content: space-around;
          flex-wrap: wrap;
          .item {
            width: 20%;
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            margin: 0.1rem 0;
            .avatar {
              width: 0.35rem;
              height: 0.35rem;
              margin: 0.05rem auto;
              border-radius: 50%;
              box-sizing: border-box;
              border: 0.02rem solid #85A5F2;
            }
            .coachName {
              width: 100%;
              height: 0.2rem;
              line-height: 0.2rem;
              font-size: 0.1rem;
              font-weight: 400;
              color: #333;
              text-align: center;
              white-space: nowrap; 
              text-overflow:ellipsis; 
              overflow:hidden; 
            }
            .btn {
              width: 0.5rem;
              height: 0.15rem;
              line-height: 0.14rem;
              font-weight: 400;
              font-size: 0.09rem;
              border: 0.01rem solid;
              border-radius: 0.1rem;
            }
            .Uncertified {
              border-color: #85A5F2;
              color: #85A5F2;
            }
            .certified {
              border-color: #D9D9D9;
              color: #D9D9D9;
            }
          }
        }
      }
      .rules {
        position: absolute;
        left: 0;
        bottom: 0.3rem;
        width: 100%;
        color: #fff;
        line-height: .2rem;
        font-size: 0.11rem;
        font-weight: 400;
        text-indent: 0.15rem;
        .activity {
          color: #F6C949;
        }
      }
    }
    .shadow {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100vh;
      background-color: rgba(0, 0, 0, 0.16);
      z-index: 100;
    }
    .share_box {
      position: fixed;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 1rem;
      background-color: #fff;
      border-top-left-radius: 0.1rem;
      border-top-right-radius: 0.1rem;
      color: #000;
      z-index: 1000;
      .box {
        display: flex;
        align-content: center;
        justify-content: space-around;
        flex-wrap: wrap;
        .item {
          width: 1rem;
          height: 0.6rem;
          img {
            width: 0.3rem;
            height: 0.3rem;
            margin: 0.1rem auto 0;
          }
          p {
            width: 100%;
            height: 0.2rem;
            line-height: 0.2rem;
            font-size: 0.1rem;
            font-weight: 500;
            text-align: center;
          }
        }
        .btn_quit {
          width: 100%;
          height: 0.3rem;
          line-height: 0.3rem;
          border-top: 0.02rem solid #000;
          font-size: 0.14rem;
          font-weight: 400;
          text-align: center;
        }
      }
    }
    .popup_box {
      position: fixed;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
      width: 2rem;
      background-color: #fff;
      z-index: 999;
      box-shadow:0 0.06rem 0.09rem 0 rgba(0, 0, 0, 0.16);
      border-radius: 0.05rem;
      overflow: hidden;
      .top {
        width: 100%;
        height: 0.1rem;
        margin-top: 0.1rem; 
        .close {
          float: right;
          margin-right: 0.1rem;
          width: 0.1rem;
          height: 0.1rem;
        }
      }
      .title {
        height: 0.15rem;
        line-height: 0.15rem;
        color: #000;
        font-size: 0.15rem;
        font-weight: 600;
        text-align: center;
      }
      .body {
        width: 100%;
        margin: 0.25rem 0; 
        position: relative;
        .coupon {
          width: 1.125rem;
          height: 0.66rem;
          margin: 0 auto;
          position: relative;
        }
        .couponCode {
          width: 100%;
          height: 0.12rem;
          line-height: 0.12rem;
          font-size: 0.13rem;
          font-weight: 600;
          color: #F6736A;
          margin: 0.14rem 0 0.12rem;
          text-align: center;
        }
        .tip {
          width: 100%;
          height: 0.08rem;
          line-height: 0.08rem;
          font-size: 0.09rem;
          font-weight: 300;
          color: #999;
          text-align: center;
        }
        .scratchWrap {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 1rem;
          #scratchWrap {
            width: 1.18rem;
            height: 1rem;
            margin: 0 auto;
          }
        }
        
        .qrcode {
          width: 1.35rem;
          height: 1.35rem;
          margin: 0 auto;
        }
        .tip1 {
          width: 100%;
          height: 0.11rem;
          line-height: 0.11rem;
          text-align: center;
          font-size: 0.12rem;
          font-weight: 300;
          color: #999;
          margin: 0.07rem 0 0.1rem;
        }
        .name {
          width: 100%;
          height: 0.14rem;
          line-height: 0.14rem;
          font-size: 0.14rem;
          font-weight: 600;
          text-align: center;
          color: #85A5F2;
        }

        .tip2 {
          width: 100%;
          height: 0.12rem;
          line-height: 0.12rem;
          text-align: center;
          font-size: 0.12rem;
          font-weight: 300;
          color: #999;
        }
        .Pastecontent {
          width: 1.75rem;
          height: 0.87rem;
          line-height: 0.18rem;
          font-size: 0.14rem;
          font-weight: 600;
          color: #85A5F2;
          margin: 0.1rem auto 0;
        }
      }
      .popupBtn {
        width: 1.5rem;
        height: 0.23rem;
        line-height: 0.23rem;
        text-align: center;
        font-size: 0.13rem;
        font-weight: 600;
        color: #fff;
        background: #85A5F2;
        border-radius: 0.12rem;
        margin: 0 auto 0.24rem;
      }
    }
    .tip_box {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100vh;
      background-color: rgba(0, 0, 0, 0.8);
      z-index: 101;
      .tip_img1 {
        width: 0.71rem;
        height: 0.94rem;
        margin: 0.2rem 0 0 2.45rem;
      }
      .tip_img2 {
        width: 1.05rem;
        height: 0.75rem;
        margin: 0 auto 0.5rem;
      }
      p {
        width: 100%;
        font-size: 0.15rem;
        font-weight: 600;
        text-align: center;
        color: #fff;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/views/activityDetail/index.vue